import { captureErrorMessage } from './analytics/error-reporting';

export const fetchApi = async (url: string) => {
  const response = await fetch(url, {
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    const message = `Failed to fetch ${url} [${response.status} status]`;
    const data = await response.json();
    void captureErrorMessage(message, data);
    throw new Error(message);
  }

  return response;
};
